import { useState, useEffect } from 'react';
import svgPaths from '../../../assets/imports/PgrmLandingPageDeslogada/svg-huqtkssm9g';
import imgBg from '../../../assets//mining_woman.png';
import { useInView } from '../../../hooks/useInView';
import { useBackEndRequests, BannerItem } from '../../backEndRequests';
import styles from './StatsBand.module.scss';

// fallback icon order kept consistent with API response order
const ICON_PATHS = [
  svgPaths.p31bca600,
  svgPaths.p21ec4560,
  svgPaths.p3d476500,
  svgPaths.p1a89cc00,
];

export function StatsBand() {
  const [ref, inView] = useInView<HTMLDivElement>();
  const { getDadosBanner } = useBackEndRequests();
  const [stats, setStats] = useState<BannerItem[]>([]);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    getDadosBanner()
      .then(setStats)
      .catch(() => setErro('Não foi possível carregar os dados do banner.'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.band} data-name='stats-band'>
      <div aria-hidden className={styles.bg}>
        <img alt='' className={styles.bgImg} src={imgBg} />
        <div className={styles.tint} />
      </div>
      <div ref={ref} className={styles.stats}>
        {erro && <p className={styles.erro}>{erro}</p>}
        {stats.map((s, i) => (
          <div
            key={s.valor}
            className={`${styles.stat} ${inView ? 'inView' : ''}`}
            style={{ transitionDelay: `${i * 0.1}s` }}
          >
            <svg
              className={styles.icon}
              fill='none'
              height='24'
              viewBox='0 0 24 24'
              width='24'
            >
              <path
                d={ICON_PATHS[i]}
                stroke='white'
                strokeLinecap='round'
                strokeWidth='2'
              />
            </svg>
            <p className={styles.value}>{s.valor}</p>
            <p className={styles.label}>{s.descricao}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
